import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSelectHostName } from '../../../utils/getSelectHostName';
import NewZealand from '@srcDS/components/atoms/icons/NewZealand';
import Australia from '@srcDS/components/atoms/icons/Australia';

export const SELECTOR_TYPES = { COMPACT: 'compact', FULLSIZE: 'fullsize' };

export const LOCALE_OPTIONS = [
  {
    label: 'NZD',
    value: 'en_AU@NZD',
    special: <NewZealand width="29px" height="17px" />,
  },
  {
    label: 'AUD',
    value: 'en_AU@AUD',
    special: <Australia width="29px" height="17px" />,
  },
];

export const useCountrySelector = ({ items, value, setValue }) => {
  const context = useSelector((state) => state.app.context);
  const [isOpen, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(context?.locale);
  const [popupPosition, setPopupPosition] = useState('bottom');
  const [loading, setLoading] = useState(false);
  const toggleDropdown = () => setOpen(!isOpen);
  const closeDropdown = () => setOpen(false);
  const { locale_mapping } = useSelector((state) => state.app.context.project.data);

  const handleItemClick = (value) => {
    setLoading(true);
    selectedItem === value ? setSelectedItem(null) : setSelectedItem(value);
    setValue(value);
    setOpen(false);
    window.location.assign(`https://${getSelectHostName(value, locale_mapping)}`);
  };

  const getCurrentOption = useCallback(() => {
    return items.find((item) => item.value === selectedItem);
  }, [items]);

  const getPopupPosition = (ref) => {
    const element = ref.current.getBoundingClientRect();
    const needHeight = element.top + element.height;
    if (needHeight * 2 < window.innerHeight) {
      return 'bottom';
    }

    return 'top';
  };

  return {
    isOpen,
    selectedItem,
    popupPosition,
    setPopupPosition,
    toggleDropdown,
    handleItemClick,
    getCurrentOption,
    getPopupPosition,
    closeDropdown,
    loading,
  };
};
